import { makeSelectors } from '@utils/css';

const flipTransitionDurationMs = 600;
const modifiers = makeSelectors({
  flipped: "_uqxf8pqw3g"
});
const wrapper = "_uqxwjwajof";
const flipWrapper = "_uqxf1agfy6a";
const cardSideWrapper = "_uqxc25plgq";
const questionSide = "_uqxqplxndg";
const answerSide = "_uqxa1gccpwc";
const cardSelectors = makeSelectors({
  cardSideWrapper
});

export { answerSide, cardSelectors, cardSideWrapper, flipTransitionDurationMs, flipWrapper, modifiers, questionSide, wrapper };
import "./_card.style.linaria.module.css";
//# sourceMappingURL=_card.style.js.map
